import React from "react";
import "./EmailFiles.css";

const EmailFiles = ({ files }) => {
    return (
        <div className="email-files animate-in">
            <h3>Your Processed File</h3>
            <table>
                <thead>
                <tr>
                    <th>📄 File Name</th>
                    <th>📬 Emails</th>
                    <th>⬇️ Download</th>
                    <th> files</th>

                </tr>
                </thead>
                <tbody>
                {files.map((file, i) => (
                    <tr key={i}>
                        <td>{file.name}</td>
                        <td>{file.emailCount}</td>
                        <td>
                            <button className="download-btn" onClick={file.downloadUrlXLSX}>Download XLSX</button>
                        </td>
                        <td>
                            <button className="download-btn" onClick={file.downloadUrlCSV}>Download CSV</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default EmailFiles;
